import React, { ReactNode } from 'react'

import { Box } from '@mui/material'

interface Props {
  icon: ReactNode
  color: Color
  large?: boolean
}

type Color = 'primary.light' | 'secondary.light' | 'info.light' | 'success.light' | 'warning.light' | 'transparent'

export const IconOnCircle = ({ icon, color, large }: Props) => {
  return (
    <Box sx={{
      position: "relative"
    }}>
      <Box
        sx={{
          height: large ? 64 * 2 : 64,
          width: large ? 64 * 2 : 64,
          overflow: 'hidden',
          position: 'relative',
          zIndex: 1,
          '& svg': { height: large ? 64 * 2 : 64, width: large ? 64 * 2 : 64 }
        }}>
        {icon}
      </Box>
      {/* 
            <Lens
                sx={{
                    color: 'warning.light',
                    height: large ? 40*2 : 40,
                    width: 'auto',
                    position: 'absolute',
                    zIndex: 'auto',
                    right: 0,
                    top: 0,
                }}
            /> */}
    </Box>
  );
}
